import navigation from "@/lang/ja/navigation";
import generics from "@/lang/ja/generics";
import questions from "@/lang/ja/questions";
import a11y from "@/lang/ja/a11y";
import velt from "@/lang/ja/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
